export default __webpack_public_path__ + "static/media/app_npc.70f4532a.png";